import { ContractorNote } from 'src/interfaces/note'
import { State } from 'src/reducers/types'

export const getContractorNotes = (state: State): Array<ContractorNote> => state.note.notes
